import { AreaMasterThemeSizeConfig } from './types';

const small: AreaMasterThemeSizeConfig = {
  areaMaster: {},
};

export default small;
